/* eslint-disable react/no-did-mount-set-state */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../../../../components/Table/PageTable';
import { trans } from '../../../../../../localization';
import {
  ModalAction,
  ModalBody,
  ModalButton,
} from '../../../../../../components/Modal/Modal';
import {
  getRestaurantsInBrand,
  goToVerifyingStep,
  selectTransferredBranch,
  stopTransferringOrder,
} from '../actions';
import NoBranchIcon from '../../../../../../assets/common/images/icon/no-branch.png';
import {
  EnumRestaurantOpenStatus,
  findEnumById,
} from '../../../../../../constants/enum';
import './TransferOrderSelectBranch.scss';
import { isEmpty } from '../../../../../../utils/utils';

const RestaurantHeader = () => {
  const columns = [
    {
      id: 'id',
      label: '',
      width: '5%',
    },
    {
      id: 'branchName',
      label: trans('restaurant_name'),
      width: '20%',
    },
    {
      id: 'address',
      label: trans('general_address'),
      width: '55%',
    },
    {
      id: 'status',
      label: trans('common_status'),
      width: '10%',
      textAlign: 'center',
    },
    {
      id: 'distance',
      label: trans('common_distance'),
      width: '10%',
      textAlign: 'center',
    },
  ];

  return <PageTableHeader columns={columns} />;
};

const InputRadio = ({ branch, onChange, checked }) => (
  <Fragment>
    <input type="radio" name="branch" checked={checked} />
    <label onClick={() => onChange(branch)}>
      <span />
    </label>
  </Fragment>
);

class TransferOrderSelectBranch extends Component {
  state = {
    isRestaurantsInBranchFetched: false,
    restaurantsInBranch: [],
  };

  async componentDidMount() {
    const { transferredOrder, getRestaurantsInBrandConnect } = this.props;
    const { restaurant } = transferredOrder || {};
    const { id: restaurantId } = restaurant || {};

    if (restaurantId) {
      const restaurantsInBranch = await getRestaurantsInBrandConnect(
        restaurantId,
      );

      this.setState({
        restaurantsInBranch,
        isRestaurantsInBranchFetched: true,
      });
    }
  }

  handleGoToNextStep = () => {
    const { selectedBranch, goToVerifyingStepConnect } = this.props;
    const { restaurant_id: restaurantId } = selectedBranch || {};

    if (!isEmpty(restaurantId)) {
      goToVerifyingStepConnect();
    }
  };

  renderRow = branch => {
    const { selectedBranch, selectTransferredBranchConnect } = this.props;
    const {
      restaurant_id: restaurantId,
      name,
      address,
      status,
      distance,
    } = branch;
    const statusEnum = findEnumById(EnumRestaurantOpenStatus, status);
    const { description: statusDescription, className } = statusEnum || {};
    const { restaurant_id: selectedRestaurantId } = selectedBranch || {};

    return (
      <PageTableRow key={restaurantId} className={className}>
        <PageTableCell>
          <InputRadio
            branch={branch}
            onChange={() => {
              if (status === EnumRestaurantOpenStatus.ONLINE.id) {
                selectTransferredBranchConnect(branch);
              }
            }}
            checked={selectedBranch && selectedRestaurantId === restaurantId}
          />
        </PageTableCell>
        <PageTableCell className="restaurant-col">{name}</PageTableCell>
        <PageTableCell>{address}</PageTableCell>
        <PageTableCell textAlign="center" className="status-col">
          {statusDescription}
        </PageTableCell>
        <PageTableCell textAlign="center">{distance}</PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const { selectedBranch, stopTransferringOrderConnect } = this.props;
    const { isRestaurantsInBranchFetched, restaurantsInBranch } = this.state;
    const table = { itemList: restaurantsInBranch };
    const isEmptyBranch = !(
      table &&
      table.itemList &&
      table.itemList.length > 0
    );

    return (
      <div className="modal-select-branch-container">
        {!isEmptyBranch && (
          <Fragment>
            <ModalBody className="modal-select-branch-body">
              <PageTable
                isPagination={false}
                isShowFooter={false}
                table={table}
                renderHeader={RestaurantHeader}
                renderRow={this.renderRow}
              />
            </ModalBody>
            <ModalAction>
              <ModalButton
                className="text-blue button-cancel"
                onClick={stopTransferringOrderConnect}
              >
                {trans('common_cancel')}
              </ModalButton>
              <ModalButton
                className="btn-blue button-confirm"
                disabled={!selectedBranch}
                onClick={this.handleGoToNextStep}
              >
                {trans('np_next')}
              </ModalButton>
            </ModalAction>
          </Fragment>
        )}

        {isEmptyBranch && isRestaurantsInBranchFetched && (
          <Fragment>
            <ModalBody className="modal-select-branch-body">
              <div className="signal-verify-container">
                <img src={NoBranchIcon} className="signal-verify" alt="icon" />
              </div>

              <p className="verifying-text">{trans('no_other_branch')}</p>
              <p className="verifying-subtext">
                {trans('no_other_suitable_branch')}
              </p>
            </ModalBody>
            <ModalAction>
              <ModalButton
                className="text-blue button-cancel"
                onClick={stopTransferringOrderConnect}
              >
                {trans('common_cancel')}
              </ModalButton>
            </ModalAction>
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  selectedBranch: state.transferOrder.selectedBranch,
  transferredOrder: state.transferOrder.transferredOrder,
});

const mapDispatchToProps = {
  stopTransferringOrderConnect: stopTransferringOrder,
  selectTransferredBranchConnect: selectTransferredBranch,
  getRestaurantsInBrandConnect: getRestaurantsInBrand,
  goToVerifyingStepConnect: goToVerifyingStep,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransferOrderSelectBranch);



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/TransferOrder/components/TransferOrderSelectBranch.jsx